<script lang="ts">
	export let touched = false;
</script>
